
import { SoftwareHero } from './components/SoftwareHero';
import { WhyLegal } from './components/WhyLegal';
import { LicenseCategories } from './components/LicenseCategories';
import { LicenseProcess } from './components/LicenseProcess';
import { SoftwareFAQ } from './components/SoftwareFAQ';
import { SoftwareCTA } from './components/SoftwareCTA';
import { SoftwareFooter } from './components/SoftwareFooter';

export default function SoftwareLegalPage() {
  return (
    <div className="min-h-screen bg-gray-950">
      <SoftwareHero />
      <WhyLegal />
      <LicenseCategories />
      <LicenseProcess />
      <SoftwareFAQ />
      <SoftwareCTA />
      <SoftwareFooter />
    </div>
  );
}
